export const IS_CHECKLIST_RECOVERY_DIAGNOSTIC =
  process.env.EXPO_PUBLIC_CHECKLIST_RECOVERY_DIAGNOSTIC === 'true';

export const RECOVERY_DIAGNOSTICS_BUCKET = 'recovery_diagnostics';
export const RECOVERY_DIAGNOSTICS_PUBLIC_KEY_ID = 'recovery_auto_2026_07_30_v1';
export const RECOVERY_DIAGNOSTICS_PUBLIC_KEY =
  process.env.EXPO_PUBLIC_RECOVERY_DIAGNOSTICS_PUBLIC_KEY?.trim() ||
  'jDWPU6sroA8JeUdQ51TTUlgx2tsqt8/Q9Ef1IiE4RHI=';
